import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getPopular } from '../redux/action/popularAction';
import { filterByPopular } from '../services/amplitude';

const Popular = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { list } = useSelector((state) => state.popular);

  useEffect(() => {
    dispatch(getPopular());
  }, []);

  const onCariHarga = (index, label) => {
    filterByPopular(label);
    const params = {
      brand: list[index].merk,
      series: list[index].seri,
      city: list[index].lokasi,
      endYear: list[index].tahun,
      cylinder: list[index].silinder,
      startYear: list[index].tahun,
      type: list[index].tipe,
      year: list[index].tahun,
    };
    history.push({
      pathname: '/popular',
      state: params,
    });
  };

  return (
    <div className="container-fluid mt-3 card shadow-sm">
      <div className="row">
        <div className="col-md-12 overview-pencarian-populer-container">
          <h6 style={{ whiteSpace: 'nowrap' }}>Pencarian Populer : </h6>
          <ul>
            {list ? (
              list.map((popular, index) => {
                return (
                  <li key={index}>
                    <a
                      className="overview-pencarian-populer overview-pencarian-populer-value"
                      style={{ whiteSpace: 'nowrap' }}
                      onClick={() => onCariHarga(index, popular.label)}
                    >
                      {popular.label}
                    </a>
                  </li>
                );
              })
            ) : (
              <p className="overview-pencarian-populer overview-pencarian-populer-value">Memuat...</p>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default Popular;
